<script setup>
import ProjectShowcase from '@/components/Projects/ProjectShowcase.vue'
</script>
<template>
    <ProjectShowcase />
</template>
